import React, {Component} from "react";
import './Landing.css';
import grad from './media/grad_pix.jpg';
import pc from './media/clker-free.png';
import mcu from './media/openclipart-vectors-device.png';
import {GitHub, Linkedin, Mail} from 'react-feather';

class Landing extends Component {
    render() {
        return (
            <div class="landing-wrapper">
                        <div class="paragraph">
                            <p>Software Engineer</p>
                            <p>&emsp;and lifelong learner</p>
                </div>
                <div class="photo">
                    
                    <img src={grad} alt="default photo" id="landing-photo" />                    
                    <img src={mcu} alt="image of microcontroller" id="microcontroller" />
                    <img src={pc} alt="image of laptop" id="laptop" />

                </div>
                <div class="right-nav">
                    <ul>
                        <a href="https://github.com/lrn-w/" id="githublink">
                            <li><i><GitHub /></i></li>
                        </a>

                        <a href="https://www.linkedin.com/in/lauren-woods1/" id="linkedinlink">
                            <li><i><Linkedin /></i></li>
                        </a>
                    </ul>
                </div>
            </div>
        );
    }
}

export default Landing;